import { Navigate, useLocation, useRoutes } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import React, { Suspense, lazy } from "react";
import Home from "./components/Pages/Home";
import { enVistaPrevia } from "./cms/sanity";
import AvisoCookies from "./components/ui/cinematic/AvisoCookies";

const AboutUs = lazy(() => import("./components/Pages/AboutUs"));
const Services = lazy(() => import("./components/Pages/Services"));
const Contact = lazy(() => import("./components/Pages/Contact"));
const Blog = lazy(() => import("./components/Pages/Blog"));
const EntradaDeBlog = lazy(() => import("./components/Pages/EntradaDeBlog"));
const NotFound = lazy(() => import("./components/Pages/NotFound"));
const ServicesDetail = lazy(() => import("./components/Pages/ServicesDetail"));
const Portfolio = lazy(() => import("./components/Pages/Portfolio"));
const PortfolioCase = lazy(() => import("./components/Pages/PortfolioCase"));
const Policy = lazy(() => import("./components/Sections/Policy/Policy"));
const Analisis360 = lazy(() => import("./components/Pages/Analisis360"));
const Links = lazy(() => import("./components/Pages/Links"));

function ScrollToTop() {
  const { pathname, search } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  // Dentro de la vista previa del panel, su barra de direcciones sigue al sitio
  React.useEffect(() => {
    if (enVistaPrevia) import("./cms/presentacion").then((m) => m.avisarRuta(`${pathname}${search}`));
  }, [pathname, search]);
  return null;
}

function PageLoader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-primary">
      <div className="w-10 h-10 border-4 border-secondary/20 border-t-secondary rounded-full animate-spin" />
    </div>
  );
}

function App() {


  const element = useRoutes([

    {
      path: "/",
      element: <Home />
    },
    {
      path: "/aboutus",
      element: <AboutUs />
    },
    {
      path: "/services",
      element: <Services />
    },
    {
      path: "/contact",
      element: <Contact />
    },
    {
      path: "/services/:id",
      element: <ServicesDetail />
    },
    {
      path: "/blog",
      element: <Blog />
    },
    {
      // El archivo completo ahora está en /blog
      path: "/blog/all",
      element: <Navigate to="/blog" replace />
    },
    {
      path: "/politica-de-privacidad",
      element: <Policy />
    },
    {
      path: "/blog/:category/:slug",
      element: <EntradaDeBlog />
    },
    {
      path: "/blog/:slug",
      element: <EntradaDeBlog />
    },
    {
      path: "/blog/id/:id",
      element: <EntradaDeBlog />
    },
    {
      path: "/portafolio",
      element: <Portfolio />
    },
    {
      path: "/portafolio/:slug",
      element: <PortfolioCase />
    },
    {
      path: "/analisis-360",
      element: <Analisis360 />
    },
    {
      path: "/links",
      element: <Links />
    },
    {
      path: "*",
      element: <NotFound />
    }

  ])

  const location = useLocation();

  if (!element) return null


  return (
    <Suspense fallback={<PageLoader />}>
      <ScrollToTop />
      <AnimatePresence mode="wait" initial={true}>
        {
          React.cloneElement(element, { key: location.pathname })
        }
      </AnimatePresence>
      <AvisoCookies />
    </Suspense>
  );
}

export default App;
